import React, { useEffect, useMemo } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { get } from 'lodash';

import ApplicationId from 'components/ApplicationId';
import Header from '../../components/Header';

const Denied = (props) => {
  const { checkinData, navigate, params, searchParams } = props;
  const strHeadLine = useMemo(() => (get(checkinData, 'data.data.hardPullDisclosure') ? 'Your loan status has changed. After further review, unfortunately we are no longer able to approve your application.' : 'Unfortunately, your application was not approved at this time.'), [checkinData]);
  const declineReason = useMemo(() => get(checkinData, 'state.data.declinedReason') || get(checkinData, 'data.data.declinedReason'), [checkinData]);
  const workflowType = get(params, 'workflowType');
  const key = searchParams.get('key');

  useEffect(() => {
    if (get(checkinData, ['data', 'data']) === undefined) {
      navigate(`${workflowType ? `/${workflowType}` : ''}/?key=${key}`);
    }
  }, []);

  return (
    <div className="transition-item wrapper v-center">
      <Header />
      <ApplicationId id={get(checkinData, 'attributes.entityId')} inHeadline />
      <div className="content">
        <h1>{strHeadLine}</h1>
        {declineReason && <p style={{ fontSize: 18 }}>{declineReason}</p>}
        <p>
          You will receive an adverse action notice within 30 days that will provide you with specific reason(s) as to why your application was not approved.
        </p>
      </div>
    </div>
  );
};

Denied.propTypes = {
  navigate: PropTypes.func.isRequired,
  checkinData: PropTypes.object.isRequired,
  params: PropTypes.object.isRequired,
  searchParams: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  checkinData: state.screen.checkinData,
});

export default connect(mapStateToProps)(Denied);
